import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M102 69.897a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M71.226 17.016a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      d="M16.415 53.793a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M26.725 82.223a1.5 1.5 0 0 1 0 2.12l-9.994 9.995a1.5 1.5 0 1 1-2.122-2.121l9.994-9.995a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M14.61 82.223a1.5 1.5 0 0 1 2.12 0l9.995 9.993a1.5 1.5 0 0 1-2.122 2.122l-9.994-9.994a1.5 1.5 0 0 1 0-2.121M107.066 38.5a1.5 1.5 0 0 1 1.5 1.5v14.134a1.5 1.5 0 0 1-3 0V40a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M98.5 47.067a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H100a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M34 28.4c0-2.43 1.954-4.4 4.364-4.4h39.273C80.047 24 82 25.97 82 28.4v57.2c0 2.43-1.954 4.4-4.364 4.4H38.365c-2.41 0-4.363-1.97-4.363-4.4z"
    />
    <path
      fill="#D8FFFF"
      d="M42 34.333C42 33.045 43.024 32 44.286 32h27.428C72.976 32 74 33.045 74 34.333v9.334C74 44.955 72.976 46 71.714 46H44.286C43.024 46 42 44.955 42 43.667z"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M43 55a3 3 0 1 1 6 0 3 3 0 1 1-6 0M43 67a3 3 0 1 1 6 0 3 3 0 1 1-6 0M43 79a3 3 0 1 1 6 0 3 3 0 1 1-6 0M55 55a3 3 0 1 1 6 0 3 3 0 1 1-6 0M55 67a3 3 0 1 1 6 0 3 3 0 1 1-6 0M55 79a3 3 0 1 1 6 0 3 3 0 1 1-6 0M67 55a3 3 0 1 1 6 0 3 3 0 1 1-6 0M67 67a3 3 0 1 1 6 0 3 3 0 1 1-6 0M67 79a3 3 0 1 1 6 0 3 3 0 1 1-6 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconEstimateInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconEstimateInverted);
export default Memo;
